import React from 'react'
import './experience.css'
import {BsTropicalStorm} from 'react-icons/bs'
import {FaGraduationCap, FaBriefcase, FaRocket} from 'react-icons/fa'

const Experience = () => {
  return (
    <section id='experience'>
      <h5>Professional Journey</h5>
      <h2>Experience & Expertise</h2>

      <div className="container experience__container">
        <div className="experience__frontend">
          <h3>Core Expertise</h3>
          <div className="experience__content">
            <article className='experience__details'>
              <BsTropicalStorm className="experience__details-icon"/>
              <div>
                <h4>Quantitative Research</h4>
                <small className='text-light'>Advanced statistical modeling, machine learning algorithms, risk management systems</small>
              </div>
            </article>
            
            <article className='experience__details'>
              <BsTropicalStorm className="experience__details-icon"/>
              <div>
                <h4>Data Infrastructure</h4>
                <small className='text-light'>Cloud-based ETL pipelines, automated data processing, enterprise-scale research platforms</small>
              </div>
            </article>
            
            <article className='experience__details'>
              <BsTropicalStorm className="experience__details-icon"/>
              <div>
                <h4>Algorithm Development</h4>
                <small className='text-light'>Pattern recognition, predictive analytics, high-performance computing solutions</small>
              </div>
            </article>
            
            <article className='experience__details'>
              <BsTropicalStorm className="experience__details-icon"/>
              <div>
                <h4>System Architecture</h4>
                <small className='text-light'>Distributed systems, blockchain protocols, scalable infrastructure design</small>
              </div>
            </article>

            <article className='experience__details'>
              <BsTropicalStorm className="experience__details-icon"/>
              <div>
                <h4>Team Leadership</h4>
                <small className='text-light'>Cross-functional collaboration, technical mentorship, strategic project management</small>
              </div>
            </article>
          </div>
        </div>

        <div className="experience__backend">
          <h3>Technical Stack</h3>
          <div className="experience__content">
            <article className='experience__details'>
              <BsTropicalStorm className="experience__details-icon"/>
              <div>
                <h4>Programming</h4>
                <small className='text-light'>Python, Go, Rust, C++, TypeScript, Solidity</small>
              </div>
            </article>
            
            <article className='experience__details'>
              <BsTropicalStorm className="experience__details-icon"/>
              <div>
                <h4>Machine Learning</h4>
                <small className='text-light'>PyTorch, Scikit-learn, XGBoost, Polars, Pandas</small>
              </div>
            </article>
            
            <article className='experience__details'>
              <BsTropicalStorm className="experience__details-icon"/>
              <div>
                <h4>Data & Analytics</h4>
                <small className='text-light'>KDB+/q, PostgreSQL, InfluxDB, Clickhouse, MongoDB</small>
              </div>
            </article>
            
            <article className='experience__details'>
              <BsTropicalStorm className="experience__details-icon"/>
              <div>
                <h4>Infrastructure</h4>
                <small className='text-light'>AWS, Docker, Kubernetes, Airflow, Nomad, Grafana, Prometheus</small>
              </div>
            </article>

            <article className='experience__details'>
              <BsTropicalStorm className="experience__details-icon"/>
              <div>
                <h4>Research Tools</h4>
                <small className='text-light'>Marimo, Git, Statistical Software</small>
              </div>
            </article>
          </div>
        </div>
      </div>

      <div className="container career-highlights">
        <h3>Career Highlights</h3>
        <div className="highlights-grid">
          <div className="highlight-card">
            <FaGraduationCap className="highlight-icon" />
            <h4>Academic Foundation</h4>
            <p>Ph.D. in Mathematics from The University of Hong Kong, specializing in stochastic processes and wavelets methods</p>
          </div>
          
          <div className="highlight-card">
            <FaBriefcase className="highlight-icon" />
            <h4>Industry Leadership</h4>
            <p>Led systematic research teams, designed ML-driven strategies, and built enterprise-grade infrastructure serving global operations</p>
          </div>
          
          <div className="highlight-card">
            <FaRocket className="highlight-icon" />
            <h4>Innovation</h4>
            <p>Co-founded blockchain ventures, pioneered trading algorithms, and developed patent-pending protocols in decentralized finance</p>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Experience
